











































import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import { rules } from "../services/validation";
import * as types from "../store/types";

export default Vue.extend({
  name: "ResetPasswordPage",

  metaInfo() {
    return {
      title: "Reset Password | ARPA Small Business - Greene County, MO",
    };
  },

  data() {
    return {
      valid: true,
      password: "",
      passwordConfirm: "",
      rules,
    };
  },

  methods: {
    ...mapActions({
      submit: types.RESET_PASSWORD,
    }),
    passwordsMatchRule(): boolean {
      return (this.password.length === 0 ||
        this.passwordConfirm.length === 0 ||
        this.password == this.passwordConfirm ||
        "Passwords do not match.") as boolean;
    },
    async validate() {
      if (this.$refs.loginForm.validate()) {
        this.submit({
          email: this.$route.query.email,
          password: this.password,
          token: this.$route.query.token,
        }).then(() => {
          if (!this.passwordErrorMessage)
            this.$router.push({
              path: "/my-account",
            });
        });
      }
    },
  },

  computed: {
    ...mapGetters({
      isSubmitting: types.RESETTING_PASSWORD,
      passwordErrorMessage: types.RESET_ERROR,
    }),
  },
});
